<template>
  <!-- <div> -->
  <div flexContainer class="orgTable">
    <div class="table_org" flex-1 flexContainer>
      <div class="button" flexContainer>
        <div flex-1></div>
        <ddbutton class="add_but" @click="openDetails">+创建应用</ddbutton>
      </div>
      <div class="table_line" flex-1>
        <el-table
          :data="tableData"
          :height="real_height + 'px'"
          :width="real_width"
          :header-cell-style="headerClass"
          :row-class-name="class_name"
          @sort-change="change_table"
        >
          <el-table-column prop="appName" label="应用" min-width="160">
          </el-table-column>
          <el-table-column
            prop="appVersion"
            label="版本号"
            min-width="120"
          ></el-table-column>
          <el-table-column label="发布时间" min-width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.updateTime | formateTitle }}</span></template
            ></el-table-column
          >
          <el-table-column
            prop="appRelease"
            label="发布人"
            width="130"
          ></el-table-column>
          <el-table-column
            prop="downloadCount"
            label="下载次数"
            min-width="130"
          ></el-table-column>
          <el-table-column
            prop="org_address"
            label="操作"
            width="180"
            fixed="right"
          >
            <template style="display: flex" slot-scope="scope">
              <span class="show_detail" @click="update_ver(scope.row)"
                >更新版本</span
              >
              <span class="download" @click="delete_var(scope.row.id)"
                >下架</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page_line">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        @current-change="table_info"
        :total="totalPage"
      ></el-pagination>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import { app_list, deleteApp } from "@/api/tool_app";
import app from "@/mixin/index";
import { mapState } from "vuex";
export default {
  mixins: [app],
  components: {
    ddbutton: () =>
      import(/* webpackChunkName: "design" */ "@/components/button"),
  },
  data() {
    return {
      value_date: "",
      start: "",
      end: "",
      page: 1,
      sort: "",
      pageSize: 50,
      totalPage: "",
      search_val: "",
      org_height: document.documentElement.clientHeight,
      real_height: document.documentElement.clientHeight - 239,
      timer: false,
      org_num: "",
      tableData: [],
      msg_obj: {},
    };
  },
  mounted() {
    this.real_height = this.org_height - 238;
    const that = this;
    window.addEventListener("resize", function () {
      that.org_height = document.documentElement.clientHeight;
    });
    that.table_info();
  },
  watch: {
    org_height(val) {
      if (!this.timer) {
        this.real_height = val - 238;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },
  computed: mapState(["isTable", "com_id", "texts_status"]),
  methods: {
    //筛选组织标签的方法 还没写完
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    //更改排序
    change_table(column, row) {
      if (column.order == "ascending") {
        this.sort = "asc";
      } else {
        this.sort = "";
      }
      this.table_info();
    },
    //清空搜索框调用方法
    go_back() {
      this.table_info();
    },
    //表格数据
    async table_info() {
      let res = await app_list();
      this.tableData = [...res.data];
    },
    //下架
    delete_var(id) {
      this.$confirm("确定下架该应用?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          let _data = {
            id: id,
          };
          deleteApp(_data).then((res) => {
            this.table_info();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch((error) => {});
    },
    update_ver(item) {
      //1 更新版本  带回信息
      this.$store.state.texts_status = 1;
      this.$router.push({ name: "create", params: item });
    },
    openDetails(row, a) {
      //2 创建应用
      this.$store.state.texts_status = 2;
      this.$router.push({ path: "/create" });
    },
  },
};
</script>
<style lang="scss" scoped>
.download {
  margin-left: 30px;
  cursor: pointer;
}
/deep/.colorLine {
  background-color: #fafcff !important;
}
/deep/.popularLine {
  background-color: #fff !important;
}
@include table;
</style>